export default {

    aiGO: {
      createNewTalk: '新建对话'
    }
  }